import React, { Component } from "react";
import { RefundTypes, SliderSettings, TicketType, TransportationType } from "../Constant";
import MyContext from "./MyContext";
import { withTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import sv from "date-fns/locale/sv";

export class MyProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trainStations: [],
      allowFileUploadExtension: props.allowFileUploadExtension,
      totalCostSEKMax: props.totalCostSEKMax,
      validateTicketNumber: props.validateTicketNumber,
      integrateTicketingSystem: props.integrateTicketingSystem,
      activeSlide: SliderSettings.initialSlide,
      caseNumber: "",
      ...this.getInitialState(),
    };
  }
  // state = this.getInitialState();

  getInitialState = () => ({
    /* state props */
    // allowFileUploadExtension: props.allowFileUploadExtension,
    registrationNumber: "",
    trainNumber: 0,
    otherComments: "",
    fromAddress: "",
    toAddress: "",
    numberOfKmDriven: "",
    transportationType: TransportationType.USEOWNCAR,
    ticketType: TicketType.SINGLE,
    ticketId: null,
    accommodationTotalCost: "",
    foodTotalCost: "",
    transportTotalCost: "",
    personalID: "",
    mobileNumber: "",
    firsname: "",
    surname: "",
    streetNameAndNumber: "",
    postalCode: "",
    city: "",
    biljettnummerValue: "",
    departureStation: null,
    departureDate: null,
    departureTime: null,
    email: "",
    username: "",
    arrivalStation: null,
    foodReceipt: [],
    transportReceipt: [],
    accommodationReceipt: [],
    refundType: RefundTypes.VIASUS,
    departureTimeOptions: null,
    declareInformation: false,
    consensus: false,
    fullTicketRefund: false,
    distance: {},
    movingoReceipt: null,
    isMovingo: false,
    accounts: [],
    otherTicketTypeValue: "",
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };

  locales = { en: undefined, sv };

  render() {
    const currentLocale = this.locales[this.props.i18n.language];
    return (
      <MyContext.Provider
        value={{
          isMovingo: this.state.isMovingo,
          changeIsMovingo: (isMovingo) => {
            this.setState({ isMovingo });
          },
          status: this.state.status,
          changeStatus: (status) => {
            this.setState({ status });
          },
          movingoReceipt: this.state.movingoReceipt,
          changeMovingoReceipt: (movingoReceipt) => {
            this.setState({ movingoReceipt });
          },
          activeSlide: this.state.activeSlide,
          changeActiveSlide: (activeSlide) => {
            this.setState({ activeSlide });
          },
          integrateTicketingSystem: this.state.integrateTicketingSystem,
          validateTicketNumber: this.state.validateTicketNumber,
          registrationNumber: this.state.registrationNumber,
          changeRegistrationNumber: (registrationNumber) => {
            this.setState({ registrationNumber });
          },
          totalCostSEKMax: this.state.totalCostSEKMax,
          changeTotalCostSEKMax: (totalCostSEKMax) => {
            this.setState({ totalCostSEKMax });
          },
          distance: this.state.distance,
          changeDistance: (distance) => {
            this.setState({ distance });
          },
          allowFileUploadExtension: this.state.allowFileUploadExtension,
          changeAllowFileUploadExtension: (allowFileUploadExtension) => {
            this.setState({ allowFileUploadExtension });
          },
          consensus: this.state.consensus,
          changeConsensus: (consensus) => {
            this.setState({ consensus });
          },
          fullTicketRefund: this.state.fullTicketRefund,
          changefullTicketRefund: (fullTicketRefund) => {
            this.setState({ fullTicketRefund });
          },
          declareInformation: this.state.declareInformation,
          changeDeclareInformation: (declareInformation) => {
            this.setState({ declareInformation });
          },
          departureTimeOptions: this.state.departureTimeOptions,
          changeDepartureTimeOptions: (departureTimeOptions) => {
            this.setState({ departureTimeOptions });
          },
          trainStations: this.state.trainStations,
          changeTrainStations: (trainStations) => {
            this.setState({ trainStations });
          },
          trainNumber: this.state.trainNumber,
          changeTrainNumber: (trainNumber) => {
            this.setState({ trainNumber });
          },
          transportationType: this.state.transportationType,
          changeTransportationType: (transportationType) => {
            this.setState({ transportationType });
          },
          refundType: this.state.refundType,
          changeRefundType: (refundType) => {
            this.setState({ refundType });
          },
          fromAddress: this.state.fromAddress,
          changeFromAddress: (fromAddress) => {
            this.setState({ fromAddress });
          },
          toAddress: this.state.toAddress,
          changeToAddress: (toAddress) => {
            this.setState({ toAddress });
          },
          numberOfKmDriven: this.state.numberOfKmDriven,
          changeNumberOfKmDriven: (numberOfKmDriven) => {
            this.setState({ numberOfKmDriven });
          },
          ticketType: this.state.ticketType,
          changeTicketType: (ticketType) => {
            this.setState({ ticketType });
          },
          ticketId: this.state.ticketId,
          changeTicketId: (ticketId) => {
            this.setState({ ticketId });
          },
          accommodationTotalCost: this.state.accommodationTotalCost,
          changeAccommodationTotalCost: (accommodationTotalCost) => {
            this.setState({ accommodationTotalCost });
          },
          transportTotalCost: this.state.transportTotalCost,
          changeTransportTotalCost: (transportTotalCost) => {
            this.setState({ transportTotalCost });
          },
          foodTotalCost: this.state.foodTotalCost,
          changeFoodTotalCost: (foodTotalCost) => {
            this.setState({ foodTotalCost });
          },
          personalID: this.state.personalID,
          changePersonalID: (personalID) => {
            this.setState({ personalID });
          },
          mobileNumber: this.state.mobileNumber,
          changeMobileNumber: (mobileNumber) => {
            this.setState({ mobileNumber });
          },
          streetNameAndNumber: this.state.streetNameAndNumber,
          changeStreetNameAndNumber: (streetNameAndNumber) => {
            this.setState({ streetNameAndNumber });
          },
          postalCode: this.state.postalCode,
          changePostalCode: (postalCode) => {
            this.setState({ postalCode });
          },
          city: this.state.city,
          changeCity: (city) => {
            this.setState({ city });
          },
          surname: this.state.surname,
          changeSurname: (surname) => {
            this.setState({ surname });
          },
          firstname: this.state.firsname,
          changeFirstname: (firsname) => {
            this.setState({ firsname });
          },
          departureDate: this.state.departureDate,
          changeDepartureDate: (departureDate) => {
            this.setState({ departureDate });
          },
          departureTime: this.state.departureTime,
          changeDepartureTime: (departureTime) => {
            this.setState({ departureTime });
          },
          email: this.state.email,
          changeEmail: (email) => {
            this.setState({ email });
          },
          biljettnummerValue: this.state.biljettnummerValue,
          changeBiljettnummerValue: (biljettnummerValue) => {
            this.setState({ biljettnummerValue });
          },
          departureStation: this.state.departureStation,
          changeDepartureStation: (departureStation) => {
            this.setState({ departureStation });
          },
          arrivalStation: this.state.arrivalStation,
          changeArrivalStation: (arrivalStation) => {
            this.setState({ arrivalStation });
          },
          username: this.state.username,
          changeUsername: (username) => {
            this.setState({ username });
          },
          delay: this.state.delay,
          changeDelay: (delay) => {
            this.setState({ delay });
          },
          compensation: this.state.compensation,
          changeCompensation: (compensation) => {
            this.setState({ compensation });
          },
          otherComments: this.state.otherComments,
          changeOtherComments: (otherComments) => {
            this.setState({ otherComments });
          },
          foodReceipt: this.state.foodReceipt,
          changeFoodReceipt: (foodReceipt) => {
            this.setState({ foodReceipt });
          },
          transportReceipt: this.state.transportReceipt,
          changeTransportReceipt: (transportReceipt) => {
            this.setState({ transportReceipt });
          },
          accommodationReceipt: this.state.accommodationReceipt,
          changeAccommodationReceipt: (accommodationReceipt) => {
            this.setState({ accommodationReceipt });
          },
          accounts: this.state.accounts,
          changeAccounts: (accounts) => {
            this.setState({ accounts });
          },
          caseNumber: this.state.caseNumber,
          changeCaseNumber: (caseNumber) => {
            this.setState({ caseNumber });
          },
          otherTicketTypeValue: this.state.otherTicketTypeValue,
          changeOtherTicketTypeValue: (otherTicketTypeValue) => {
            this.setState({ otherTicketTypeValue });
          },
          resetState: () => {
            this.resetState();
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={currentLocale}>
          {this.props.children}
        </LocalizationProvider>
      </MyContext.Provider>
    );
  }
}

export default withTranslation()(MyProvider);
